export const RatioOfPreviewCard = 1.493; // width of card in panel / width of preview card
